import { BaseModel } from "sjs-base-model";
import configuration from '../../utilities/configuration';
import FilterableSubscriptionRequestModel from "../../models/filterableSubscriptionRequest/FilterableSubscriptionRequestModel"
import * as EffectUtility from "../../utilities/EffectUtility";

export async function requestAllFilterableSubscriptionRequests() {
    const endpoint = configuration.apiServer + configuration.apiFilterableSubscriptionRequestsPath;
    return EffectUtility.getToModel(FilterableSubscriptionRequestModel, endpoint);
}

export async function createFilterableSubscriptionRequest(userId, newFilterableSubscriptionRequest) {
    const endpoint = configuration.apiServer + configuration.apiFilterableSubscriptionRequestsPath + "/" + userId;
    return EffectUtility.postToModel(BaseModel, endpoint, newFilterableSubscriptionRequest, true, true);
}

export async function confirmFilterableSubscriptionRequest(subscriptionRequestId) {
    const endpoint = configuration.apiServer + configuration.apiFilterableSubscriptionRequestsPath + "/" + subscriptionRequestId + "/confirm";
    return EffectUtility.postToModel(BaseModel, endpoint);
}

export async function rejectFilterableSubscriptionRequest(subscriptionRequestId) {
    const endpoint = configuration.apiServer + configuration.apiFilterableSubscriptionRequestsPath + "/" + subscriptionRequestId + "/reject";
    return EffectUtility.postToModel(BaseModel, endpoint);
}
